import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    path: String,
    props: Object,
  };

  root = null;

  async connect() {
    if (!this.hasPathValue) return;
    await this.renderReact();
  }

  async renderReact() {
    if (this.root) return;

    try {
      const [{ createElement }, { createRoot }, module] = await Promise.all([
        import("react"),
        import("react-dom/client"),
        import(
          /* webpackInclude: /\.(js|jsx)$/ */ `../../../${this.pathValue}`
        ),
      ]);

      const Component = module.default;

      this.root = createRoot(this.element);
      this.root.render(createElement(Component, this.propsValue || {}));
    } catch (e) {
      console.error("React Component Render Error:", e);
    }
  }

  // disconnect() {
  //   if (this.root) {
  //     this.root.unmount();
  //     this.root = null;
  //   }
  // }
}
